// extracted by mini-css-extract-plugin
export var externalLink = "_8d-0";
export var internalLinkLabel = "_8d-1";